import React, { FC } from 'react';
import Link from 'next/link';

interface Props {
  text: string;
  link: string;
}

const GrayLink: FC<Props> = ({ text, link }) => {
  return (
    <div className='inline-block border-b border-gray-50 hover:border-primary h-7'>
      <Link href={link}>
        <a className='cursor-pointer body-paragraph text-gray-50 hover:text-primary'>{text}</a>
      </Link>
    </div>
  );
};

export default GrayLink;
